// extracted by mini-css-extract-plugin
export default {"header":"EventsNavigation_header__iyos6","list":"EventsNavigation_list__6wVKN","active":"EventsNavigation_active__0FTnZ"};